<template>
  <div style="width: 100%;height: 100%;">
    <iframe src="static/login" frameborder="0" width="100%" height="100%" ref="login"></iframe>
  </div>
</template>

<script type="text/ecmascript-6">
import { login } from '../api/userMG'
export default {
  name: 'login',
  data() {
    return {
      //定义loading默认为false
      logining: false,
      min: true,
    }
  },
  methods: {
    submitForm(formName) {
      if(formName != undefined){
        login(formName).then(res => {
            if (res.code == 0) {
              setTimeout(() => {
                this.logining = false
                // 缓存token
                localStorage.setItem('logintoken', res.data.token)
                // 缓存用户个人信息
                localStorage.setItem('userdata', JSON.stringify(res.data))
                this.$store.commit('login', 'true')
                this.$router.push({ path: '/base/index' })
              }, 1000)
            } else {
              this.$message.error(res.msg)
              this.logining = false
              return false
            }
          }) 
      }
    },
  },
   mounted() {
      let self = this;
      window["goBack"] = (data) => {
          self.submitForm(data);
      };
      window["errormsg"] = (msg) => {
          self.$message.error(msg)
      };
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/login.vue